import {Card} from "flowbite-react";
import React from "react";
import {ArrowUp, ArrowDown} from "flowbite-react-icons/outline";


export const EmptyTopProductCard = () => {
    return <Card className="w-full sl-text-left relative ">
        <div className={"flex flex-col  sl-justify-space-between"}
             style={{height: "176px"}}>
            <span className={"skeleton-loader"} style={{
                "display": "flex",
                "width": "228px",
                "height": "12px",
                "flexDirection": "column",
                "justifyContent": "center",
                "alignItems": "center"
            }
            }/>

            <div className={"flex flex-row sl-gap-2"}>
                <div className={"skeleton-loader"} style={{
                    "display": "flex",
                    "width": "64px",
                    "height": "28px",
                    "flexDirection": "column",
                    "justifyContent": "center",
                    "alignItems": "center"
                }}/>

                <div className={"skeleton-loader"} style={{
                    "display": "flex",
                    "width": "48px",
                    "height": "10px",
                    "flexDirection": "column",
                    "justifyContent": "center",
                    "alignItems": "center",
                    "margin": "auto",
                    "marginLeft": "0"

                }}/>
            </div>

            <div className={"flex flex-row sl-justify-space-between"}>
                <div className={"skeleton-loader"} style={{
                    "display": "flex",
                    "width": "139px",
                    "height": "12px",
                    "flexDirection": "column",
                    "justifyContent": "center",
                    "alignItems": "center"
                }}/>

                <div className={"skeleton-loader"} style={{
                    "display": "flex",
                    "width": "60px",
                    "height": "12px",
                    "flexDirection": "column",
                    "justifyContent": "center",
                    "alignItems": "center"
                }}/>
            </div>
        </div>
    </Card>
};


const TopProductCard = ({name, searches, position, position_old}) => {

    const hideDiff = position !== 0 && position_old === 0;

    let diff = position_old - position;
    if (diff && !Number.isInteger(diff)) {
        diff = diff.toFixed(1);
    }
    diff = diff.toString();

    if (diff[0] !== '-') {
        diff = '+' + diff;
    }
    let isZero = (position - position_old) === 0
    let isAverageZero = false;
    const isPositive = diff[0] === '+';


    let averagePosition = position;

    if (position && !Number.isInteger(position)) {
        averagePosition = position.toFixed(1);
    }

    if (searches > 0 && position === 0) {
        averagePosition = '25+'
    }

    if (averagePosition === 0 && searches === 0)
        isAverageZero = true;


    return <Card className="w-full sl-text-left relative">

                        <span className="text-gray-900 sl-text-md sl-font-medium ">
                        {name}
                    </span>
        <div className={"flex flex-row sl-gap-2"}>
            <span className="text-gray-900 sl-text-xxl sl-font-semibold ">{searches}</span>
            <span className={"sl-m-auto sl-ml-0"}>Searches</span>
        </div>
        <div className={"flex flex-row justify-between"}>
                        <span className={"sl-text-gray-500 sl-text-sm"}>Average position: <span
                            className={"sl-text-gray-700 sl-text-md sl-font-semibold"}>{averagePosition}</span> </span>


            {isZero && !isAverageZero && !hideDiff &&
                <div
                    className={"sl-bg-gray-100 sl-pl-2 sl-pr-2 sl-align-center sl-border-radius-16 flex flex-row gap-1"}>
                    <span className={"sl-text-gray-700 sl-font-medium sl-text-sm"}>0</span>
                </div>}


            {isPositive && !isZero && !isAverageZero && !hideDiff &&
                <div
                    className={"sl-bg-success-50 sl-pl-2 sl-pr-2 sl-align-center sl-border-radius-16 flex flex-row gap-1"}>

                    <ArrowUp size={12} className={"sl-text-success-300 sl-text-sm sl-font-medium"}/>
                    <span className={"sl-text-success-700 sl-font-medium sl-text-sm"}>{diff}</span>
                </div>}

            {!isPositive && !isZero && !isAverageZero && !hideDiff &&
                <div
                    className={"sl-bg-error-50 sl-pl-2 sl-pr-2 sl-align-center sl-border-radius-16 flex flex-row gap-1"}>
                    <ArrowDown size={12} className={"sl-text-error-300 sl-text-sm sl-font-medium"}/>
                    <span className={"sl-text-error-700 sl-font-medium sl-text-sm"}>{diff}</span>
                </div>}

        </div>
    </Card>
}

export default TopProductCard;
